const DeliveryMethods = [
  {
    id: 1,
    name: 'Online (link)',
    label: 'Online (link)',
  },
  {
    id: 2,
    name: 'Classroom (location)',
    label: 'Classroom (location)',
  },
  {
    id: 3,
    name: 'Other (specify)',
    label: 'Other (specify)',
  },
];

export default DeliveryMethods;
